import { __decorate, __extends } from "tslib";
import { CustomElement, upgradeProperty, attachShadowTemplate } from '@tyler-components-web/core';
import { RADIO_CONSTANTS } from './radio-constants';
import { RadioFoundation } from './radio-foundation';
import { RadioAdapter } from './radio-adapter';
var template = require('./radio.html');
var styles = require('./radio.css');
/**
 * The custom element class behind the `<tcw-radio>` element.
 */
var RadioComponent = /** @class */ (function (_super) {
    __extends(RadioComponent, _super);
    function RadioComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, RADIO_CONSTANTS.elementName, template, styles);
        _this._foundation = new RadioFoundation(new RadioAdapter(_this));
        return _this;
    }
    Object.defineProperty(RadioComponent, "observedAttributes", {
        get: function () {
            return [
                RADIO_CONSTANTS.attributes.DENSE
            ];
        },
        enumerable: true,
        configurable: true
    });
    RadioComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'dense');
    };
    RadioComponent.prototype.connectedCallback = function () {
        var _this = this;
        this._ensureRadioInputElement().then(function () { return _this._foundation.connect(); });
    };
    RadioComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    RadioComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case RADIO_CONSTANTS.attributes.DENSE:
                this.dense = this.hasAttribute(RADIO_CONSTANTS.attributes.DENSE);
                break;
        }
    };
    RadioComponent.prototype._ensureRadioInputElement = function () {
        var _this = this;
        // Not using core function ensureChild because it was not selecting the input properly
        return new Promise(function (resolve) {
            var element = _this.querySelector(RADIO_CONSTANTS.selectors.RADIO_INPUT);
            if (element) {
                resolve();
                return;
            }
            var observer = new MutationObserver(function (changes) {
                var hasAddedNodes = changes.reduce(function (prev, curr) { return prev + curr.addedNodes.length; }, 0) > 0;
                if (hasAddedNodes) {
                    if (_this.querySelector(RADIO_CONSTANTS.selectors.RADIO_INPUT)) {
                        observer.disconnect();
                        resolve();
                    }
                }
            });
            observer.observe(_this, { childList: true, subtree: true });
        });
    };
    RadioComponent.prototype.syncCheckedState = function () {
        this._foundation.syncCheckedState();
    };
    Object.defineProperty(RadioComponent.prototype, "dense", {
        /** Gets/sets whether the radio button is dense. */
        get: function () {
            return this._foundation.dense;
        },
        set: function (value) {
            this._foundation.dense = value;
        },
        enumerable: true,
        configurable: true
    });
    RadioComponent = __decorate([
        CustomElement({
            name: RADIO_CONSTANTS.elementName
        })
    ], RadioComponent);
    return RadioComponent;
}(HTMLElement));
export { RadioComponent };
